module.exports = __webpack_public_path__ + "static/img/Planificaciones_5_formatos@4x.fc1a253d.png";